import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { colors } from '@ui/colors'
import Button from '@ui/buttons/Button'
import { ButtonProps } from '@ui/buttons/Button/types'
import { ModalBottom } from '@ui/components/Modal'

interface Props {
  open: boolean
  onClose: () => void
  onCancel?: () => void
  isPending?: boolean
  onConfirm: () => void
  title: string
  desc: string
  confirmLabel?: string
  cancelLabel?: string
  buttonConfirmProps?: ButtonProps
  buttonCancelProps?: ButtonProps
}

export default function ConfirmationModal({
  title,
  desc,
  open,
  onClose,
  onCancel,
  onConfirm,
  isPending,
  confirmLabel,
  cancelLabel,
  buttonConfirmProps,
  buttonCancelProps,
}: Props) {
  const { t } = useTranslation(['ui'])
  return (
    <ModalBottom
      open={open}
      close={onClose}
      title={title}
      desc={desc}
      spacedText
      body={
        <View className="flex-row items-center gap-8 px-16">
          <Button
            variant="filled"
            label={confirmLabel ?? t('ui:yesContinue')}
            loading={isPending}
            colors={[colors.red[600], colors.red[700]]}
            onPress={onConfirm}
            {...buttonConfirmProps}
          />
          <Button
            variant="outlined"
            label={cancelLabel ?? t('ui:cancel')}
            onPress={onCancel ?? onClose}
            noninteractive={isPending}
            {...buttonCancelProps}
          />
        </View>
      }
    />
  )
}
